import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

// Query Keys
export const predictionCblQueryKeys = {
  all: ['predictionCbl'],
  data: (stationSysIdList, targetDate) => [
    ...predictionCblQueryKeys.all, 
    'data', 
    stationSysIdList ? stationSysIdList.sort().join(',') : 'empty', 
    targetDate
  ],
};

export const powerMeterDemandQueryKeys = {
  all: ['powerMeterDemand'],
  data: (stationSysIdList, targetDate) => [
    ...powerMeterDemandQueryKeys.all, 
    'data', 
    stationSysIdList ? stationSysIdList.sort().join(',') : 'empty', 
    targetDate
  ],
};

export const livePowerMeterDemandQueryKeys = {
  all: ['livePowerMeterDemand'],
  data: (stationSysIdList, targetDate) => [
    ...livePowerMeterDemandQueryKeys.all, 
    'data', 
    stationSysIdList ? stationSysIdList.sort().join(',') : 'empty', 
    targetDate
  ],
};

export const liveCblDataQueryKeys = {
  all: ['liveCblData'],
  data: (stationSysIdList, targetDate) => [
    ...liveCblDataQueryKeys.all, 
    'data', 
    stationSysIdList ? stationSysIdList.sort().join(',') : 'empty', 
    targetDate
  ],
};

// PredictionCblData 조회
export const usePredictionCblPackData = (stationSysIdList, targetDate, cblModuleName, cblModuleVersion, options = {}) => {
  const baseEnabled = !!stationSysIdList && Array.isArray(stationSysIdList) && stationSysIdList.length > 0 && !!targetDate;
  const isEnabled = baseEnabled && (options.enabled !== undefined ? options.enabled : true);
  
  
  return useQuery({
    queryKey: predictionCblQueryKeys.data(stationSysIdList, targetDate),
    queryFn: () => {
      return api.post('/drivecore/predictioncbl/api/PredictionCblData/pack', {
        targetDate,
        stationSysIdList,
        cblModuleName,
        cblModuleVersion
      });
    },
    staleTime: 5 * 60 * 1000, // 5분간 fresh 상태 유지
    cacheTime: 15 * 60 * 1000, // 15분간 메모리에 보관
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options,
    enabled: isEnabled,
  });
};

// 특정일 전력 수요 조회 (어제 전력 수요)
export const usePowerMeterDemandPackData = (stationSysIdList, targetDate, options = {}) => {
  const baseEnabled = !!stationSysIdList && Array.isArray(stationSysIdList) && stationSysIdList.length > 0 && !!targetDate;
  const isEnabled = baseEnabled && (options.enabled !== undefined ? options.enabled : true);
  
  return useQuery({
    queryKey: powerMeterDemandQueryKeys.data(stationSysIdList, targetDate),
    queryFn: () => {
      return api.post('/drivecore/pd/api/PowerMeterDemand/pack', {
        targetDate,
        stationSysIdList
      });
    },
    staleTime: 5 * 60 * 1000, // 5분간 fresh 상태 유지
    cacheTime: 15 * 60 * 1000, // 15분간 메모리에 보관
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options,
    enabled: isEnabled,
  });
};

export const useLivePowerMeterDemandPackData = (stationSysIdList, targetDate, options = {}) => {
  const baseEnabled = !!stationSysIdList && Array.isArray(stationSysIdList) && stationSysIdList.length > 0 && !!targetDate;
  const isEnabled = baseEnabled && (options.enabled !== undefined ? options.enabled : true);
  
  return useQuery({
    queryKey: livePowerMeterDemandQueryKeys.data(stationSysIdList, targetDate),
    queryFn: () => {
      return api.post('/drivecore/pd/api/LivePowerMeterDemand/pack', {
        targetDate,
        stationSysIdList
      });
    },
    staleTime: 5 * 60 * 1000, // 5분간 fresh 상태 유지
    cacheTime: 15 * 60 * 1000, // 15분간 메모리에 보관
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options,
    enabled: isEnabled,
  });
};

// 실시간 예측 CBL
export const useLiveCblDataPackData = (stationSysIdList, targetDate, alModelName, alModelVersion, options = {}) => {
  const baseEnabled = !!stationSysIdList && Array.isArray(stationSysIdList) && stationSysIdList.length > 0 && !!targetDate;
  const isEnabled = baseEnabled && (options.enabled !== undefined ? options.enabled : true);
  
  return useQuery({
    queryKey: liveCblDataQueryKeys.data(stationSysIdList, targetDate),
    queryFn: () => {
      return api.post('/drivecore/livecbl/api/LiveCblData/pack', {
        alModelName,
        alModelVersion,
        targetDate,
        stationSysIdList
      });
    },
    staleTime: 5 * 60 * 1000, // 5분간 fresh 상태 유지
    cacheTime: 15 * 60 * 1000, // 15분간 메모리에 보관
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options,
    enabled: isEnabled,
  });
};

export default {
  usePredictionCblPackData,
  usePowerMeterDemandPackData,
  useLivePowerMeterDemandPackData,
  useLiveCblDataPackData,
};
